import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { TemplateData, useGetTemplates, useGetTemplateById, TemplateDataHouse } from "./templates";
import { NameAndId } from "../../data";

type TemplateStateProps = {
  template?: TemplateData;
  isClientType: boolean;
  categoryId?: number;
  isOrder?: boolean;
  isAdmin?: boolean;
  onComplete: (templateId: any, imageUrl?: string) => void;
};
type createContextProps = {
  changeClientType: (isClient: boolean) => void;
  changeCategory: (newId?: number) => void;
  changeTemplate: (template?: TemplateData, imageUrl?: string) => void;
  state: TemplateStateProps;
  apiTemplates?: TemplateDataHouse;
};
const TemplateContext = createContext({} as createContextProps);

type TemplateContextProdiverProps = {
  children: React.ReactNode;
  isOrder?: boolean;
  isAdmin?: boolean;
  onComplete?: (templateId: any, imageUrl?: string) => void;
};

export const TemplateContextProdiver = ({ children, isOrder = false, onComplete = () => {}, isAdmin = false }: TemplateContextProdiverProps) => {
  const [state, setState] = useState({ isOrder, onComplete, isClientType: false, isAdmin } as TemplateStateProps);
  const { data: apiTemplates } = useGetTemplates();
  const { mutate: downloadBody } = useGetTemplateById();
  const handleChange = (params: any) => {
    setState((prev) => ({ ...prev, ...params }));
  };

  const changeTemplate = (template?: TemplateData) => {
 

    if (!template) {
      handleChange({ template: undefined });
      return;
    }
    downloadBody(template.id, {
      onSuccess: (data) => {
        handleChange({ template: data });
      },
    });
  };
  const changeCategory = (newId?: number) => handleChange({ categoryId: newId });
  const changeClientType = (isClient: boolean) => handleChange({ isClientType: isClient });
  const providerValue: createContextProps = useMemo(() => {
    return {
      state,
      apiTemplates,
      changeClientType,
      changeCategory,
      changeTemplate,
    };
  }, [apiTemplates, state]);
  return <TemplateContext.Provider value={providerValue}>{children}</TemplateContext.Provider>;
};

export const useTemplateContext = () => {
  return useContext(TemplateContext);
};
